import {get} from 'lodash-es';
import {notNil} from '@megaphonenpm/mputils/src/utils.js';

export class DeploymentSettingsService {
  constructor () {
  }

  /**
   * Returns a Set of URIs for media in deployment settings.
   *
   * @param deploymentSettings A JSON deployment settings object.
   * @param clientType One of the client-type contants, such as CLIENT_TYPE_SCREEN or CLIENT_TYPE_CONTROLLER.
   * @returns {Set<any>} A Set of media URLs for the specified clientType.
   */
  getDeploymentSettingsMediaURIs (deploymentSettings, clientType) {
    let uris = new Set();
    let mediaTypes = ['background', 'cta', 'foreground', 'show', 'sponsor'];

    mediaTypes.forEach(mediaType => {
      let path = `defaults.content.${mediaType}.media.${clientType}.uri`;
      let uri = get(deploymentSettings, path);
      if (notNil(uri) && uri !== '') {
        uris.add(uri);
      }
    });

    return uris;
  }
}

